import { render, staticRenderFns } from "./SpcDocumentsTransport.vue?vue&type=template&id=9a6f13ce&scoped=true"
import script from "./SpcDocumentsTransport.vue?vue&type=script&lang=js"
export * from "./SpcDocumentsTransport.vue?vue&type=script&lang=js"
import style0 from "./SpcDocumentsTransport.vue?vue&type=style&index=0&id=9a6f13ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6f13ce",
  null
  
)

export default component.exports